export default {
    msgList: [], // 消息列表
    msgTotal: 0, // 消息总计
    msgDetail: null, // 消息详情
    notifyList: [], // 消息通知面板列表
    visibleNotify: false // 显示通知面板
};
